import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchTestData } from "../../api/utils";

const Home = () => {
  const { test_id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [testData, setTestData] = useState([]);
  const [acknowledged, setAcknowledged] = useState(false);
  const navigate = useNavigate();
  // Warn before leaving the page (reload, close, back button)
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "Leaving will end the test.";
      return "Leaving will end the test.";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Detect tab switching
  // useEffect(() => {
  //   const handleBlur = () => {
  //     alert("Tab switching is not allowed. This will end the test.");
  //     // You could auto-submit or end the test here.
  //   };
  //   window.addEventListener("blur", handleBlur);
  //   return () => {
  //     window.removeEventListener("blur", handleBlur);
  //   };
  // }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const test_data = await fetchTestData(test_id);
      if (test_data.status) {
        const data = test_data.data;
        setTestData(data);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setTimeout(() => {
          alert("You have exited fullscreen. This will end the test.");
          // Optionally, redirect or submit test here
          // window.location.href = "/test-ended";
        }, 50);
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  // Fullscreen request
  const goFullscreen = async () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      await elem.requestFullscreen();
    }
    navigate("/examination/home/exam/test/"+test_id,{
      state: {
        test_data: testData,
        test_id, test_id
      }
    });
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <span className="head-text h1 mb-4">Test Rules & Instructions</span>
      <p className="mt-4">
        Please read the following rules carefully. This test must be taken under
        strict conditions. By clicking "I Acknowledge," you confirm that you
        understand and agree to abide by these rules.
      </p>

      <ul>
        <li>
          The test will run in fullscreen mode. You must not exit fullscreen
          during the test.
        </li>
        <li>
          Attempting to switch tabs, minimize the window, or leave the page will
          automatically end the test.
        </li>
        <li>
          Closing the browser, refreshing, or navigating away from the test page
          will end the test.
        </li>
        <li>
          Any attempt to cheat or bypass the rules will result in automatic
          termination of the test.
        </li>
      </ul>

      <div style={{ marginTop: "1.5rem" }}>
        <label>
          <input
            type="checkbox"
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
            style={{ marginRight: "0.5rem" }}
          />
          I have read and understood the rules. I acknowledge that violating
          them will end the test.
        </label>
      </div>

      <button
        onClick={goFullscreen}
        disabled={!acknowledged}
        className="primary-button btn-lg btn btn-primary w-20 rounded-pill mt-4"
        style={{
          marginTop: "1.5rem",
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          cursor: acknowledged ? "pointer" : "not-allowed",
          backgroundColor: acknowledged ? "#007bff" : "#ccc",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
        }}
      >
        Enter Fullscreen & Begin Test
      </button>
    </div>
  );
};

export default Home;
